import { Shape } from './Shape.js'
export class Point extends Shape {
	x
	y
	designation
	hitBoxPadding = 20
	constructor(x, y, properties = {}) {
		super()
		this.x = x
		this.y = y
		this.properties = properties
	}
	move(dx, dy) {
		this.x += dx
		this.y += dy
		if (this.parent && this.parent.updateHitBox) {
			this.parent.updateHitBox()
		}
	}
	render(context, options = {
		pixelsPerMeter: 1,
		pixelRatio: 1
	}) {
		const pixelRatio = options.pixelRatio ?? 1
		const circleRadius = 6 * pixelRatio
		const fontSize = 18 * pixelRatio
		let color = this.properties.color ?? 'white'
		let textColor = this.properties.textColor ?? 'black'
		if (this.selected) {
			color = 'rgba(255,190,0,1)'
		} else if (this.highlighted) {
			color = 'rgba(255,190,0,0.5)'
		}
		context.save()
		context.textAlign = 'center'
		context.baseline = 'middle'
		if (this.properties.name) {
			context.font = `500 ${fontSize}pt/1 "Tietoevry sans 1",sans-serif`
			const measureMents = context.measureText(this.properties.name)
			const y = (measureMents.actualBoundingBoxAscent - measureMents.actualBoundingBoxDescent) / 2
			// draw roudned rect behind text
			let padding = 30
			context.beginPath()
			context.roundRect(this.x - measureMents.width / 2 - padding/2, this.y - y - padding/2, measureMents.width + padding, y * 2 + padding, 10)
			context.fillStyle = color
			context.fill()
			context.fillStyle = textColor
			context.fillText(this.properties.name, this.x, this.y + y)
		} else {
			context.fillStyle = color
			context.beginPath()
			context.arc(this.x, this.y, circleRadius, 0, 2 * Math.PI)
			context.fill()
		}
		context.restore()
	}
	handleForPoint(point) {
		return this.isInside(point) ? this : null
	}
	isInside(point) {
		if (Math.abs(this.x - point.x) < this.hitBoxPadding && Math.abs(this.y - point.y) < this.hitBoxPadding) {
			return true
		}
		return false
	}
	toJSON() {
		return {
			type: 'Point',
			x: this.x,
			y: this.y,
			properties: this.properties
		}
	}
	getType() {
		return 'Line'
	}
}
